import EventClient from "@2u-landing-pages/utils/event-client";
import { useEffect, useState } from "react";
import { filterKeyMap, FilterOption } from "../../FilterBar.types";
import { ButtonsNav } from "./ButtonsNav";

type ButtonsFilterProps = {
  filterGroup: [string, FilterOption[]] | undefined;
  filters: any;
  setFilters: Function;
  style?: string;
};

export const ButtonsFilter: React.FC<ButtonsFilterProps> = ({ filterGroup, filters, setFilters, style}) => {
  const [activeFilter, setActiveFilter] = useState<number | null>(null);
  const filterOptions = filterGroup?.[1].map((option: FilterOption) => option.name);

  useEffect(() => {
    if (Object.keys(filters).length === 0 || Object.entries(filters)[0][1] === null) {
      setActiveFilter(filterOptions && filterOptions.length > 1 ? 0 : null);
    }
  }, [filters, filterOptions]);

  const handleBtnClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number, label?: string) => {
    setActiveFilter(index);
    const key = filterKeyMap[filterGroup?.[0] as keyof typeof filterKeyMap];

    setFilters({
      [key]: label ? [label] : null,
    });

    EventClient.elementClicked({
      webElement: {
        elementType: key,
        htmlId: "select",
        location: "Buttons Filter",
        name: label,
        position: key,
        text: label,
      },
    });
  };

  return <ButtonsNav filterOptions={filterOptions || []} activeFilter={activeFilter} handleBtnClick={handleBtnClick} style={style} />;
};
